module.exports = __webpack_public_path__ + "img/Avatar-70.ad948426.svg";